import { subGeometryDisplayName } from './tabs/subGeometries/helpers';

export const SUB_REGION_NONE = '__none__';

export function buildSubRegionItems(
  subGeometries: { id: string; name: string | null }[],
): { value: string; label: string }[] {
  return [
    { value: SUB_REGION_NONE, label: 'None (unscoped)' },
    ...subGeometries.map((sg) => ({ value: sg.id, label: subGeometryDisplayName(sg.name) })),
  ];
}

export const subRegionFormValue = (id: string | null): string => id ?? SUB_REGION_NONE;
export const subRegionFkValue = (formValue: string): string | null =>
  formValue === SUB_REGION_NONE ? null : formValue;
